import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { refreshPriceApparat } from "../../store/actions/paymentsActions";

export default function useLivePrintModes() {
    const dispatch = useDispatch();
    useEffect(() => {
        const refresh = () => { if (localStorage.getItem("deviceToken")) dispatch(refreshPriceApparat()); };
        const unsubscribe = window.electronAPI?.onSettingsUpdated?.(refresh);
        const timer = setInterval(refresh, 30000);
        return () => { clearInterval(timer); unsubscribe?.(); };
    }, [dispatch]);
}
